module.exports = __webpack_public_path__ + "static/media/MascotNew.8a1babb8.png";